import axios from "../../service";
import { BannerService } from "../resources";
export const state = {
  storeBanner: {}
};

export const mutations = {
  INIT_ADDR_LIST(state, newValue) {
    state.addressList = newValue;
  }
};

export const getters = {};

export const actions = {
  async getBanner({ commit }, data) {
    try {
      let resp = await BannerService.apiGetBanner();
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  }
};
